import CurrencyMixin from 'mixins/currency-mixin'

export default {
  name: 'faq-box-v2',

  props: {
    title: {
      required: true,
      type: String
    },
    locationName: {
      required: false,
      type: String
    },
    rentalCompanyName: {
      required: false,
      type: String
    },
    seoData: {
      type: Object,
      required: false
    },
    seoRentalData: {
      type: Object,
      required: false
    },
    type: {
      required: false,
      type: String,
      default: ''
    },
    knowBeforeRent: {
      type: Object,
      required: false
    },
    categoryMinPrice: {
      type: Array,
      required: false
    }
  },

  mixins: [CurrencyMixin],

  data() {
    return {
      moreDetails: false
    }
  },

  computed: {
    schemaAttrs() {
      return {
        itemscope: true,
        itemprop: 'mainEntity',
        itemtype: 'https://schema.org/Question'
      }
    },
    rentalDataTranslations() {
      return {
        MIN_VALUE: this.formatCurrency(this.seoRentalData.cheapestRentalRate, this.$store.getters.getCurrency),
        POP_LOCATIONS: this.seoRentalData?.mostPopularPickupLocations?.length ? this.seoRentalData.mostPopularPickupLocations.join(', ') : '',
        NUM_STORES: this.seoRentalData?.availableStores,
        POP_GROUPS: this.seoRentalData?.mostPopularCategory ? this.seoRentalData?.mostPopularCategory : '',
        COMPANY: this.rentalCompanyName,
        MODEL: this.seoRentalData?.mostPopularCarModel ? this.seoRentalData?.mostPopularCarModel : '',
        GROUPS: this.seoRentalData?.carAllCategoriesAvaliable.length ? this.seoRentalData?.carAllCategoriesAvaliable?.join(', ') : ''
      }
    },

    cityDataTranslations () {
      return {
        MIN_VALUE: this.getMinValue(),
        MIN_COMPANY: this.getMinGroup(),
        BEST_COMPANY: this.getBestCompany(),
        CITY: this.locationName,
        POP_MODEL: this.seoData?.vehicles?.[0]?.vehicle,
        AVG_VALUE: this.seoData?.ticket30days?.ticket ? this.formatCurrency(this.seoData.ticket30days.ticket, this.$store.getters.getCurrency) : '',
        NUM_STORES: this.seoData?.rentalAviability[0]?.store,
        NUM_COMPANIES: this.seoData?.rentalAviability[0]?.group,
        CATEGORIES: this.seoData?.rentalAviabilityCategoryName?.join(', ')
      }
    }
  },

  async mounted() {
    this.knowBeforeRent = await this.isKnowBeforeRent()
  },

  methods: {
    getFilteredItems(list, dataTranslations) {
      const items = !this.moreDetails ? list.slice(0, 3) : list
      return items.filter(item => this.validateFilters(item.description, dataTranslations))
    },
    // valida se todas as chaves da descrição contém valor.
    validateFilters(description, dataTranslations) {
      for (const key in dataTranslations) {
        if (description.includes(`{{${key}}}`) && typeof dataTranslations[key] === 'undefined') {
          return false
        }
      }
      return true
    },

    filteredStrings(item, filters) {
      return item.toString()
        .replace(/<\/?p>/gi, '')
        .replace(/{{(CITY|BEST_COMPANY|MIN_VALUE|MIN_COMPANY|POP_MODEL|AVG_VALUE|NUM_COMPANIES|NUM_STORES|CATEGORIES|POP_LOCATIONS|GROUPS|POP_GROUPS|COMPANY|MODEL|STORES_QUANTITY)}}/g, value => filters[value.toString().replace(/{{|}}/g, '')])
    },

    getMinValue() {
      if (this.categoryMinPrice?.length > 0) {
        return `${this.categoryMinPrice[0]?.currency} ${this.categoryMinPrice[0]?.value}`
      }
      return ''
    },

    getMinGroup() {
      if (this.seoData !== null && this.seoData?.minBooking30days?.group) {
        return this.seoData.minBooking30days.group
      }
      return ''
    },

    getBestCompany() {
      if (this.seoData !== null && this.seoData?.nps?.length > 0) {
        return this.seoData.nps[0].group
      }
      return ''
    },

    isKnowBeforeRent() {
      const regex = /{{(MIN_VALUE|MIN_COMPANY|BEST_COMPANY)}}/g
      if (this.type !== 'rental') {
        this.knowBeforeRent.City?.tip.forEach((item, index, object) => {
          if ((regex.test(item.description)) && ((this.getMinValue() === '') || (this.getBestCompany() === ''))) {
            object.splice(index, 1)
          }
        })
      }
      return this.knowBeforeRent
    }
  }
}
